import {createSelector} from 'reselect';

const selectState = (state) => state.advancedDiagnostic;

const selectIsDiagnosticPhase2 = createSelector(selectState, (state) => state.isPhase2);

const selectIsDiagnosticFlow = createSelector(selectState, (state) => state.isDiagnosticFlow);

const selectIsDiagnosticFlowDataCollectionInProgress = createSelector(
    selectState,
    (state) => state.isDiagnosticFlowDataCollectionInProgress
);

const selectDiagnosticFlowDataResult = createSelector(selectState, (state) => state.diagnosticFlowDataResult);

const selectFailedAttempts = createSelector(selectState, (state) => state.failedAttempts);

export {
    selectDiagnosticFlowDataResult,
    selectFailedAttempts,
    selectIsDiagnosticFlow,
    selectIsDiagnosticFlowDataCollectionInProgress,
    selectIsDiagnosticPhase2,
};
